import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Iframe from 'react-iframe';
import { clearActiveOffers, getActiveOffers } from 'store/appTrack/actions';
import { clearMapDetails, setMapDetails } from 'store/staticPages/actions';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';

const AreaForm = () => {
  const iframeRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [details, setDetails] = useState({});
  const user = useSelector(state => state.user);

  const clearData = () => {
    dispatch(clearMapDetails());
  };

  window.onmessage = function (event) {
    if (event.data?.address) {
      setDetails(event.data);
      // dispatch(setMapDetails(event.data));
    }
  };

  useEffect(() => {
    let providers = details?.providers;
    let provider =
      !isEmpty(providers) && isArray(providers)
        ? providers?.find(p => p.coverid === details?.coverid)
        : '';
    let infrprov = provider?.infrprov ?? '';

    if (infrprov) dispatch(getActiveOffers(infrprov));
    else dispatch(clearActiveOffers());
  }, [details, dispatch]);

  return (
    <div id="map-page" className="mt-5 static-map-page">
      <p className="color-blue-3 text-bold font-size-24 mt-6 mb-3">
        Περιοχή Δραστηριότητας
      </p>
      <ul>
        <li>
          <>
            Στη μπάρα αναζήτησης «Εισάγετε διεύθυνση» συμπληρώστε τη διεύθυνση
            του κτιρίου (όλη ή μέρος αυτής) για το οποίο επιθυμείτε να ελέγξετε
            την επιλεξιμότητά του.
          </>
        </li>
        <br></br>
        <li>
          <>
            Μεταφέρεστε αυτόματα στο σημείο του χάρτη που πιθανόν βρίσκεται το
            κτίριο.
          </>
        </li>
        <br></br>
        <li>
          <>
            Πατήστε πάνω στο σημείο που αντιστοιχεί στο κτίριο της επιλογής σας
            και εφόσον τα στοιχεία είναι ορθά, επιλέξτε «Προσθήκη».
          </>
        </li>
        <br></br>
      </ul>
      {
        <div id="iframe-wrapper">
          {/*iframe */}
          <Iframe
            // url={`${process.env.REACT_APP_XEDM_URL}?user=${userVat}`}
            url={`${process.env.REACT_APP_XEDM_URL}?user=gigabitUser`}
            width="100%"
            height="500px"
            innerRef={iframeRef}
            id="XEDM"
            className=""
            display="block"
            position="relative"
          />
        </div>
      }
      <div
        id="go-to-login-button"
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <Button
          id="platform-login-button"
          onClick={() => {
            dispatch(
              setMapDetails({
                payload: details,
                callback: () => {
                  setTimeout(clearData, 300000); //clear data after 5 minutes have passed from clicking the button
                  navigate(user?.status ? '/apptrack' : '/login');
                },
              })
            );
          }}
          className="badges-button map-page"
        >
          Είσοδος στην πλατφόρμα →
        </Button>
      </div>
    </div>
  );
};

export default AreaForm;
